import React, { useState } from 'react';
import {
  Box,
  Typography,
  Stack,
  Tabs,
  Tab,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Button,
  IconButton,
} from '@mui/material';
import {
  WarningAmber,
  Groups,
  People,
  EmojiEventsOutlined,
} from '@mui/icons-material';
import CommonWrapper from 'Components/Common/CommonWrapper';

// Mock data for the table, matching the image content
const archivedCasesData = [
  {
    id: 1,
    name: 'Walmart : Confidence Interval and CLT',
    questions: 1,
    score: '0.0/100',
    solvedBy: '07',
    dueDate: '9 Nov 2024',
  },
  {
    id: 2,
    name: 'Aerofit : Descriptive Statistics & Probability',
    questions: 1,
    score: '0.0/100',
    solvedBy: '06',
    dueDate: '20 Oct 2024',
  },
  {
    id: 3,
    name: 'Netflix : Data Exploration and Visualisation',
    questions: 1,
    score: '0.0/100',
    solvedBy: '07',
    dueDate: '28 Sep 2024',
  },
  {
    id: 4,
    name: 'Target: SQL',
    questions: 1,
    score: '0.0/100',
    solvedBy: '04',
    dueDate: '16 Jun 2024',
  },
];

const headerCells = ['Business Case', 'Questions', 'Score', 'Status', 'Solved By', 'Due Date', 'Actions'];

// A helper component for the countdown timer
const CountdownTimer = () => (
    <Stack direction="column" alignItems="center" spacing={1.5}>
        <Typography variant="body2" color="text.secondary">Deadline for the Business Case :</Typography>
        <Stack direction="row" alignItems="center" spacing={1}>
            {['10d', '02h', '16m', '30s'].map((time, index) => (
                <React.Fragment key={time}>
                    <Paper variant="outlined" sx={{ px: 0.8, py: 0.8, borderColor: 'border.blue', borderRadius: 2 }}>
                        <Typography color="error.main" fontWeight={500}>{time}</Typography>
                    </Paper>
                    {index < 3 && <Typography color="text.secondary">:</Typography>}
                </React.Fragment>
            ))}
        </Stack>
    </Stack>
);

const ArchivedCasesPage = () => {
  // Set the default active tab to "Archived Business Cases" (index 1)
  const [tabIndex, setTabIndex] = useState(1);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <CommonWrapper width="lg">
      <Box sx={{ p: { xs: 2, md: 4 }, bgcolor: 'background.paper' }}>
        <Stack spacing={3}>
          {/* Tabs */}
          <Box>
            <Tabs value={tabIndex} onChange={handleTabChange} TabIndicatorProps={{ hidden: true }} type="button">
              <Tab value={1} label="Active Business Cases" />
              <Tab value={2} label="Archived Business Cases" />
            </Tabs>
          </Box>

          {/* Important Info Banner */}
          { tabIndex === 2 &&
            <Paper elevation={0} sx={{ p: 2, bgcolor: 'yellow.main', borderRadius: 2 }}>
              <Typography color="secondary.light">
                <Typography component="span" fontWeight="bold" color="secondary.main">
                  Important:
                </Typography>
                {' '}Your archived business cases (from other batches) in this section do not affect current Business Case PSP.
              </Typography>
            </Paper>
          }

          {/* Table Container */}
          <TableContainer>
            <Table>
              <TableHead sx={{ bgcolor: 'background.default' }}>
                <TableRow>
                  {headerCells.map((header) => (
                    <TableCell align="center" key={header}>
                      <Typography variant="body2" fontWeight="bold" color="secondary.main">{header}</Typography>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {archivedCasesData.map((row, index) => (
                  <TableRow key={row.id}>
                    <TableCell align="center">
                      <Typography variant="body1" color="secondary.main" fontWeight="500">
                        {row.name}
                      </Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Typography variant="body1" color="secondary.light">{row.questions}</Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Typography variant="body1" color="secondary.light">{row.score}</Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Chip
                        icon={<WarningAmber color="error" fontSize="24px" />}
                        label="Not Attempted"
                        color="error" variant="outlined" outlined rectangle 
                        // iconPosition="start"
                        sx={{
                          m: 0,
                          gap: 1,
                          alignItems: 'center'
                        }}
                        // sx={{
                        //   bgcolor: 'error.light',
                        //   color: 'error.main',
                        //   fontWeight: '500',
                        //   borderRadius: '6px',
                        //   height: 'auto',
                        //   p: '6px 10px',
                        //   '& .MuiChip-label': { p: 0 },
                        //   '& .MuiChip-icon': { ml: '6px', mr: '-4px' },
                        // }}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <Stack direction="row" alignItems="center" spacing={0.5}>
                        <People sx={{color: 'secondary.light'}} />
                        <Typography variant="body1" color="secondary.light">{row.solvedBy}</Typography>
                      </Stack>
                    </TableCell>
                    <TableCell align="center">
                      { index === 0 ?
                        <CountdownTimer /> :
                        <Typography variant="body1" color="error.main">{row.dueDate}</Typography>
                      }
                    </TableCell>
                    <TableCell align="center">
                      <Stack direction="row" alignItems="center" spacing={1.5}>
                        <IconButton sx={{ border: '1px solid', borderColor: 'border.grey', borderRadius: 2, p: '6px' }}>
                          <EmojiEventsOutlined sx={{ color: 'secondary.light' }}/>
                        </IconButton>
                        <Button variant="contained">Solve</Button>
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Stack>
      </Box>
    </CommonWrapper>
  );
};

export default ArchivedCasesPage;